import React, { createContext, useContext, useState, useEffect } from 'react';
import pb from '../lib/pocketbase';

const SiteSettingsContext = createContext({
    showContact: true,
    loading: true,
    refresh: () => { }
});

export const useSiteSettings = () => useContext(SiteSettingsContext);

export const SiteSettingsProvider = ({ children }) => {
    const [showContact, setShowContact] = useState(true);
    const [loading, setLoading] = useState(true);

    const loadSettings = async () => {
        try {
            // Get the first record from site_settings
            const records = await pb.collection('site_settings').getList(1, 1);
            if (records.items.length > 0) {
                setShowContact(records.items[0].show_contact !== false);
            }
        } catch (err) {
            console.error("Error loading site settings:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadSettings();
    }, []);

    return (
        <SiteSettingsContext.Provider value={{ showContact, loading, refresh: loadSettings }}>
            {children}
        </SiteSettingsContext.Provider>
    );
};
